import { render, staticRenderFns } from "./PromoCoversGrid.vue?vue&type=template&id=37edd3db&scoped=true"
import script from "./PromoCoversGrid.vue?vue&type=script&lang=js"
export * from "./PromoCoversGrid.vue?vue&type=script&lang=js"
import style0 from "./PromoCoversGrid.vue?vue&type=style&index=0&id=37edd3db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37edd3db",
  null
  
)

export default component.exports